import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import { GiftOrderDetailResponse } from '@models/gift';
import { useRef } from 'react';

import useCompleteAnimation from './hooks/useCompleteAnimation';
import styles from './styles.module.scss';

interface Props {
    response: GiftOrderDetailResponse;
}
function Complete({ response }:Props) {
  const ref = useRef<HTMLDivElement>(null);
  const cardRef = useRef<HTMLImageElement>(null);
  const imageUrl = response?.detail.giftItem.imageUrl;
  useCompleteAnimation({ ref, cardRef });
  return (
        <div className={styles.container}
             ref={ref}>
            <div className={styles.cardWrapper}>
                <Image src={imageUrl}
                       width={300}
                       height={200}
                       ref={cardRef}
                       className={styles.card}
                       alt='카드 이미지' />
            </div>
            <Column align='center' spacing={18}>
                <Text color={colors.gray7} size='3xl' fontWeight='bold' >
                    카드 선물이 완료되었습니다!
                </Text>
            </Column>
        </div>
  );
}

export default Complete;
